import React from 'react';

import { Row, Form, Input } from 'antd';
import { useIntl } from 'react-intl';
import { renderCombo } from 'src/components/account/addresses';

const NewAddressForm = ({
  handleEditInput,
  getLabelName,
  stateList,
  formFields,
}) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Row justify="start" align="middle" className="buy-modal__title-add">
        {formatMessage({ id: 'shopping-cart.buy-modal.add-title' })}
      </Row>
      {formFields.map((field) => {
        return field.isCombo ? (
          <Row key={field.name} className="input-row">
            <Form.Item name={field.name}>
              {renderCombo(stateList, handleEditInput)}
            </Form.Item>
            <span className={getLabelName(field.name)}>
              {field.completeName}
            </span>
          </Row>
        ) : (
          <Row key={field.name} className="input-row">
            <Form.Item name={field.name}>
              <Input
                type={field.isNumber ? 'number' : 'string'}
                required
                onChange={(e) => handleEditInput(field.name, e.target.value)}
              />
            </Form.Item>
            <span className={getLabelName(field.name)}>
              {field.completeName}
            </span>
          </Row>
        );
      })}
    </>
  );
};

export default NewAddressForm;
